var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisabledEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "7CDDFA11-854D-4C6D-BF1C-B21B9384F8F3-3889-0008A0EB732BD03C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "v1-Final",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "New-Patient-Profile-page-:-Consult-Consolidated-1-prod",
    transform: "translate(-1141.000000, -492.000000)",
    fill: "#CCCCCC",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Consolidated-Consult-1-Product-Profile",
    transform: "translate(420.000000, 375.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M732.714286,122.526786 L734.196429,121.044643 C734.416667,120.824405 734.526786,120.556548 734.526786,120.241071 C734.526786,119.931548 734.416667,119.660714 734.196429,119.428571 L734.196429,119.428571 L732.098214,117.339286 C731.872024,117.113095 731.60119,117 731.285714,117 C730.964286,117 730.696429,117.113095 730.482143,117.339286 L730.482143,117.339286 L729,118.8125 L732.714286,122.526786 Z M724.714286,130.526786 L732.142857,123.098214 L728.428571,119.383929 L721,126.8125 L721,130.526786 L724.714286,130.526786 Z M723.857143,126.151786 C723.72619,126.151786 723.660714,126.08631 723.660714,125.955357 C723.660714,125.895833 723.681548,125.845238 723.723214,125.803571 L723.723214,125.803571 L728.5625,120.964286 C728.604167,120.922619 728.654762,120.901786 728.714286,120.901786 C728.845238,120.901786 728.910714,120.967262 728.910714,121.098214 C728.910714,121.157738 728.889881,121.208333 728.848214,121.25 L728.848214,121.25 L724.008929,126.089286 C723.967262,126.130952 723.916667,126.151786 723.857143,126.151786 Z M724.241071,129.383929 L723.285714,129.383929 L723.285714,128.241071 L722.142857,128.241071 L722.142857,127.285714 L722.955357,126.473214 L725.053571,128.571429 L724.241071,129.383929 Z",
    id: "icon-edit.svg"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledEditIcon);
export default __webpack_public_path__ + "static/media/disabledEditIcon.3d5cb96bf8baaecef8755f3bc012f0e1.svg";
export { ForwardRef as ReactComponent };